<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-5">
        <h3>WIP Panel Types</h3>
      </v-col>
      <v-col class="text-end">
        <v-btn
          color="primary"
          outlined
          @click="openWipPanelTypeForm"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New WIP Panel Type
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="wipPanelTypes"
            :footer-props="footerProps"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.id`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.id }}
              </text-highlight>
            </template>
            <template #[`item.code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.code }}
              </text-highlight>
            </template>
            <template #[`item.is_listed`]="{ item }">
              <text-highlight :queries="search">
                {{ item.is_listed  ? 'Yes' : 'No'}}
              </text-highlight>
            </template>
            <template #[`item.description`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.description }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEditWipPanelTypeForm(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="deleteWipPanelType(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <wip-panel-type-form
      ref="wipPanelTypeForm"
      @success="getWIPPanelTypes"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import WipPanelTypeForm from '@/components/forms/wipPanels/WipPanelTypeForm.vue';

export default {
  components: {
    WipPanelTypeForm,
  },
  props: {

  },
  data: () => ({
    wipPanelTypes: [],
    loading: false,
    headers: [
      { text: 'Type#', value: 'id', sortable: false },
      { text: 'Code', value: 'code', sortable: false },
      { text: 'Is Listed', value: 'is_listed', sortable: false },
      { text: 'Description', value: 'description', sortable: false },
      {
        text: 'Actions', value: 'actions', width: '15%', align: 'end', sortable: false,
      },
    ],
    footerProps: {
      'items-per-page-options': [20, 50, 100, -1],
    },
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getWIPPanelTypes();
    },

    async getWIPPanelTypes() {
      const res = await this.$api.wipPanelType.read();
      this.wipPanelTypes = res.data;
    },

    openWipPanelTypeForm() {
      this.$refs.wipPanelTypeForm.open();
    },

    openEditWipPanelTypeForm(id) {
      this.$refs.wipPanelTypeForm.open(id);
    },

    async deleteWipPanelType(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      const res = await this.$api.wipPanelType.delete(id);
      console.log(res)
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.getWIPPanelTypes();
    },
  },
};
</script>

<style scoped>

</style>
